<template>
  <header class="dtva-header">
    <div class="dtva-header__main">
      <!-- eslint-disable -->
      <a v-if="!isLoggedIn" href="#/" class="dtva-header__name">{{ this.$i18n.t('APP.LOGO.DREI') }}<span class="text--blue">{{ this.$i18n.t('APP.LOGO.TV') }}</span></a>
      <span v-if="isLoggedIn" class="dtva-header__name">{{ this.$i18n.t('APP.LOGO.DREI') }}<span class="text--blue">{{ this.$i18n.t('APP.LOGO.TV') }}</span></span>
      <!-- eslint-enable -->
      <div
        v-if="isLoggedIn"
        class="dtva-header__quicklinks"
      >
        <logout-button />
      </div>
    </div>
    <nav
      class="dtva-header__nav-entries"
      aria-label="Site menu"
    >
      <div
        v-if="isLoggedIn"
      >
        <router-link
          class="dtva-header__nav-entry"
          :to="{name: ROUTE_TOPUP}"
          :active-class="isActiveTab(ROUTE_TOPUP)"
        >
          {{ this.$i18n.t('APP.TOP_MENU.TOPUP') }}
        </router-link>
        <router-link
          class="dtva-header__nav-entry"
          :to="{name: ROUTE_MANAGE}"
          :active-class="isActiveTab(ROUTE_MANAGE)"
        >
          {{ this.$i18n.t('APP.TOP_MENU.STREAMING_CARD') }}
        </router-link>
        <router-link
          class="dtva-header__nav-entry"
          :to="{name: PROFILE}"
          :active-class="isActiveTab(PROFILE)"
        >
          {{ this.$i18n.t('APP.TOP_MENU.PROFILE') }}
        </router-link>
      </div>
      <div
        v-if="!isLoggedIn"
      >
        <router-link
          class="dtva-header__nav-entry"
          :to="{name: ROUTE_LOGIN}"
          :active-class="isActiveTab(ROUTE_LOGIN)"
        >
          {{ this.$i18n.t('APP.TOP_MENU.LOGIN') }}
        </router-link>
        <router-link
          class="dtva-header__nav-entry"
          :to="{name: ROUTE_ACTIVATION}"
          :active-class="isActiveTab(ROUTE_ACTIVATION)"
        >
          {{ this.$i18n.t('APP.TOP_MENU.ACTIVATION') }}
        </router-link>
      </div>
    </nav>
  </header>
</template>

<script>
import LogoutButton from "../navigation/LogoutButton.vue";

export default {
  name: "DtvaHeader",
  components: { LogoutButton },
  props : {
    currentRouteName: {
        type: String,
        required: true
    }
  },
  data: function() {
    return {
      ROUTE_LANDING: 'landing',
      ROUTE_TOPUP: 'topUp',
      ROUTE_MANAGE: 'manage',
      PROFILE: 'profile',
      ROUTE_LOGIN: 'login',
      ROUTE_ACTIVATION: 'activation'
    }
  },
  computed: {
    isLoggedIn: function() {
      return this.$store.state.userDetail != null;
    }
  },
  methods: {
    isActiveTab(...args) {
      for (let i = 0; i < args.length; i += 1) {
        if (this.currentRouteName === args[i]) {
          return 'dtva-header__nav-entry--active';
        }
      }
      return '';
    },
  }
}
</script>

<style lang="scss" src="./dtva-header.scss">
</style>
